


















































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class extends Vue {
  newsletterDialog: boolean = false;

  valid: boolean = false;

  emailRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'Email address required',

    (v: string) =>
      v8n()
        .pattern(/\S+@\S+\.\S+/)
        .test(v) || 'Email address must be valid',
  ];

  socialLinks = [
    {
      platform: 'Facebook',
      icon: 'mdi-facebook-box',
      link: 'https://www.facebook.com/GowansAuctions/',
    },
    {
      platform: 'Instagram',
      icon: 'mdi-instagram',
      link: 'https://www.instagram.com/gowansauctions/',
    },
  ];

  menu = [
    {
      title: 'About',
      to: {
        path: '/about/',
      },
      show: () => true,
    },
    {
      title: 'Buying',
      to: {
        path: '/buying/',
      },
      show: () => true,
    },
    {
      title: 'Selling',
      to: {
        path: '/selling/',
      },
      show: () => true,
    },
    {
      title: 'Auctions',
      to: {
        url: 'https://gowans.bidsonline.com.au/',
      },
      show: () => true,
    },
    {
      title: 'Contact',
      to: {
        name: 'contact',
      },
      show: () => true,
    },
    {
      title: 'Terms & Conditions',
      to: {
        url: 'https://www.gowansauctions.com.au/terms-and-conditions/',
      },
      show: () => true,
    },
  ];

  get filteredMenu() {
    return this.menu.filter(item => item.show());
  }

  async mounted() {
    const newsletterScript = document.createElement('script');
    newsletterScript.setAttribute(
      'src',
      'https://js.createsend1.com/javascript/copypastesubscribeformlogic.js',
    );
    document.head.appendChild(newsletterScript);
  }
}
